import type { EdgeId, TopologyEdgeData } from '../edges';
import type { TopologyNodeData } from '../nodes';
import type { NodeId } from '../nodes/types';

export interface TopologyGraphData {
  nodes: Record<NodeId, TopologyNodeData>;
  edges: Record<EdgeId, TopologyEdgeData>;
}
